// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"modal_wrapper__r22GH","p1":"modal_p1__8YDXi","onlineDesc":"modal_onlineDesc__2v2df","lpHeading":"modal_lpHeading__uUo1L"};